import React, { type ComponentType, type ReactElement } from 'react';

import { IntlProvider as ReactNextIntlProvider, useIntl } from 'react-intl-next';

import { useFetchMessagesByLocale } from './useFetchMessagesByLocale';

interface IntlProviderType {
	children: ReactElement<any>;
}

export const withLocalIntl =
	<Props extends NonNullable<unknown>>(ComponentToWrap: ComponentType<Props>) =>
	(props: Props) => (
		<LocalIntlProvider>
			<ComponentToWrap {...props} />
		</LocalIntlProvider>
	);

export const LocalIntlProvider = ({ children }: IntlProviderType) => {
	const { locale } = useIntl();
	const { messages } = useFetchMessagesByLocale(locale);

	return (
		<ReactNextIntlProvider messages={messages} key={locale} locale={locale}>
			{children}
		</ReactNextIntlProvider>
	);
};
